function emptyPopup(elem) {
    // haal alle divs eruit
    var divs = elem.getElementsByTagName('div');
    for (var i = 0; i < divs.length; i++) {
        elem.removeChild(divs[i]);
    }
}